export default "__VITE_ASSET__BosdL7Lj__"